export default "__VITE_ASSET__DiBbSmJn__"